module.exports = __webpack_public_path__ + "img/pageinteriors_02administracion-de-riesgos-02.08eb6db9.jpg";